import { render, staticRenderFns } from "./folders-to-open-access.vue?vue&type=template&id=06391cee&scoped=true"
import script from "./folders-to-open-access.vue?vue&type=script&lang=js"
export * from "./folders-to-open-access.vue?vue&type=script&lang=js"
import style0 from "./folders-to-open-access.vue?vue&type=style&index=0&id=06391cee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06391cee",
  null
  
)

export default component.exports